import {useTranslation} from "react-i18next";

export default function UsedByHospitals() {
    const {t} = useTranslation();
    return (
        <div className="bg-white">
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                <p className="text-center text-base font-semibold uppercase text-gray-600 tracking-wider">
                    {t('home.trusted-by.title')}
                </p>
                <div className="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-8">
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img
                            className="max-h-12"
                            src="https://www.cliniqueaeroport.com/wp-content/uploads/2016/11/logo_CLINIQUE_AEROPORT_200.png"
                            alt="Workcation"
                        />
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img className="max-h-12" src="http://www.churabat.ma/images/logo-chis.png" alt="Mirage"/>
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img className="max-h-12"
                             src="https://www.chumarrakech.ma/wp-content/uploads/2016/04/logoCHU.png" alt="Tuple"/>
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img className="max-h-12"
                             src="http://www.annugeo.com/images/photos/ag43-clinique-avicenne-tunisie.gif"
                             alt="Clinique Avicienne"/>
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img
                            className="max-h-12"
                            src="http://www.scrim.ma/wp-content/uploads/2016/07/CHU-Oujda.jpg"
                            alt="StaticKit"
                        />
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img
                            className="max-h-12"
                            src="http://www.chu-fes.ma/wp-content/uploads/2017/11/Logo_CHU-final.png"
                            alt="Statamic"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
